export default __webpack_public_path__ + "static/media/Carosel HO 4.456661cd.svg";